import { render, staticRenderFns } from "./vodreset.vue?vue&type=template&id=bc5b9ee2&scoped=true&"
import script from "./vodreset.vue?vue&type=script&lang=js&"
export * from "./vodreset.vue?vue&type=script&lang=js&"
import style0 from "./vodreset.vue?vue&type=style&index=0&id=bc5b9ee2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5b9ee2",
  null
  
)

export default component.exports